import React, { useState, useMemo } from 'react'

import Button from 'components_new/atoms/Button'

import SimpleDialog from 'components_new/molecules/SimpleDialog'

import EditVariableSection from './EditVariableSection'

import { KpiVariable } from 'types/GlobalKpiVariable'
import { useTranslation } from 'language/translator'

interface AddVariableDialogProps {
  onClose: () => void
  onSave: (name: string) => void
  open: boolean
  variables: KpiVariable[]
}

const AddVariableDialog = (props: AddVariableDialogProps) => {
  const { variables, onClose, onSave, open } = props
  const { t } = useTranslation()

  const [editName, setEditName] = useState<string>('')

  const isDuplicate = useMemo(() => {
    return !!variables.find((v) => v.name === editName)
  }, [editName])

  return (
    <SimpleDialog
      title={t('accounting', 'add_account_level')}
      open={open}
      onClose={() => {
        onClose()
        setEditName('')
      }}
      actions={
        <>
          <Button
            variant="text"
            onClick={() => {
              onClose()
              setEditName('')
            }}
          >
            {t('global', 'cancel')}
          </Button>
          <Button
            disabled={!editName || isDuplicate}
            variant="contained"
            onClick={() => {
              onSave(editName)
              setEditName('')
            }}
          >
            {t('global', 'save')}
          </Button>
        </>
      }
    >
      <EditVariableSection
        editName={editName}
        isDuplicate={isDuplicate}
        setEditName={setEditName}
      />
    </SimpleDialog>
  )
}

export default AddVariableDialog
